import { useTheme } from "styled-components";

export default function Footer() {
  const currentTheme = useTheme();
  return (
    <footer
      className={`absolute right-5 bottom-5 mb-5 xl:bottom-8 2xl:mb-0 md:pr-4 ${currentTheme.textPrimary} text-sm font-mono tracking-wide`}
    >
      version - 1.0.0
    </footer>
  );
}
